import { ArticleCard } from 'experiences/learn/articles/ArticleCard'
import { ArticleSummary } from 'services/ContentfulService/models/articles'
import { Reel } from 'ui/primitives/Reel'
import { card } from './ArticleSection.css'
import { Box, FlexBox } from 'ui/primitives'

type Props = { articles: Array<ArticleSummary> }

export const ArticleSection = ({ articles }: Props) => {
	const mappedArticles = articles.map(article => (
		<div key={article.id} className={card}>
			<ArticleCard article={article} mode="standard" />
		</div>
	))

	return (
		<>
			<Box display={{ xs: 'block', xl: 'none' }} style={{ margin: '0 -1rem' }}>
				<Reel>{mappedArticles}</Reel>
			</Box>
			<FlexBox display={{ xs: 'none', xl: 'flex' }} gap="xl">
				{mappedArticles}
			</FlexBox>
		</>
	)
}
